import * as Sentry from "@sentry/astro";

Sentry.init({
  enabled: import.meta.env.PROD,
  dsn: "https://0b8acd08ded0e7ea5569513e5123ff7c@o62445.ingest.us.sentry.io/4508666603110400",
  sendDefaultPii: true,
});
